"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _acl = require("./acl");
Object.keys(_acl).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _acl[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _acl[key];
    }
  });
});